import { LocaleName } from "@/app/i18n/settings";
import { Company } from "@/types/company";
import { getLocalizedRoute } from "@/utils/localized-route";

export function createCompanyURI(company: Company, language: string) {
  //Generate Link for this item by replacing spaces with underscores and dots with $DOT. German links are different from english ones for some reason
  return getLocalizedRoute(
    language as LocaleName,
    `publicProfile/${encodeURIComponent(company.id)}`,
  );
}

export function removeHttps(url: string | undefined): string | undefined {
  if (url) {
    return url.replace("https://", "").replace("http://", "");
  }
  return url;
}
